import { getBookingDetailsPageLink } from 'lib/links';
import { useDetailsBooking, useScrollTopOnMount } from 'lib/hooks';
import * as track from 'lib/gaTracking/cancelBookingPageEvents';
import { Container } from '@qga/roo-ui/components';
import LoadingBlock from 'components/LoadingBlock';
import CancellationPolicyAlert from 'components/CancellationPolicyAlert';
import { TwoColumnWithBookingSummary } from 'components/Layout';
import CancellationPageLayout from '../CancellationPageLayout';
import { useCancellationQuote } from '../CancellationQuoteProvider';
import PropertyCharges from '../PropertyCharges';
import ActionBar from '../ActionBar';
import RefundSummary from '../RefundSummary';
import PaymentSummary from 'components/PaymentSummary';
import { bookingToPaymentSummaryProps } from 'components/PaymentSummary/utils';
import { InPathFlightBookingAlert } from 'components/InPathFlightBookingAlert';

const ReviewCancellation = () => {
  const { booking } = useDetailsBooking();
  const { cancellation, cancellationState } = useCancellationQuote();
  const detailsPageLink = getBookingDetailsPageLink(booking.id);
  useScrollTopOnMount();

  return (
    <CancellationPageLayout>
      <Container pt={12} pb={0}>
        <InPathFlightBookingAlert m={0} />
      </Container>
      <TwoColumnWithBookingSummary heading="Confirm your cancellation and review any fees & charges" showSummaryOnMobile>
        {cancellationState === 'QUOTING' || !cancellation ? (
          <LoadingBlock />
        ) : (
          <>
            <PaymentSummary {...bookingToPaymentSummaryProps(booking)} />
            <CancellationPolicyAlert mb={[5, 8]} />
            <PropertyCharges penalty={cancellation.refund!.penalty} />
            <RefundSummary />
            <ActionBar backLinkUrl={detailsPageLink} onClickBackLink={track.manageBookingReturnLinkBottomSelected} />
          </>
        )}
      </TwoColumnWithBookingSummary>
    </CancellationPageLayout>
  );
};

export default ReviewCancellation;
